import React,{ useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const KdcNews = (props) =>{
    const [newsdata,setNewsdata ] = useState({});
    const [currentIndex, setCurrentIndex] = useState(0);
    const [newsList, setNewsList] = useState([]);
    const maxVisibleItems = 3; // 한 번에 표시할 card 수
    const history = useNavigate();

    useEffect(()=>{
        getNotice();
        getReleaseNote();
    }, [])

    const getNotice = async () => {
        const response = await fetch('datas/oper/news.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Cache-Control': 'no-cache'
            }
        });
        const result = await response.json();
        setNewsdata(result);
    }
    const getReleaseNote = async () => {
        const response = await fetch('/api/Document/GetReleaseContentList', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                workingTag: "News",
                pageNum: 1,
                rowNum: 20
            })
        });
        if(response.status === 200) {
            const result = await response.json();
            if(result.table && result.table.length > 0) {
                getCardList(result.table);
            }
        }
    }
    const getCardList = (postDatas) => {
        const list = [];
        for(let i = 0; i < postDatas.length; i += maxVisibleItems) {
            list.push(postDatas.slice(i, i + maxVisibleItems))
        }
        setNewsList(list);
    }
    const getCard = (postdata, index) => { 
        if (!newsdata || !newsdata.children) return null;
        const newslist = newsdata.children.find( (newsInfo) => {if(newsInfo.groupno == JSON.parse(postdata.content).groupNo) return newsInfo;});       
        return(
            <li key={index} className="kdcnews-card" onClick={() => moveNews(postdata.content)}>
                <div className={`card-top-${newslist.id}`}>
                </div>
                <div className="card-bottom">
                    <p className={`kdcnews-tag-${newslist.id}`}>{newslist.title}</p>
                    <h3 className="kdcnews-box-title">{postdata.title}</h3>
                    <p className="date">{postdata.updateDate}</p>
                </div>
            </li>
        );
    }
    const moveNews = (postData) => {
        history("/News", {state: JSON.parse(postData)});
    }

    const handleNext = () => {
        if (currentIndex + 1 < newsList.length) {
            setCurrentIndex(prev => prev + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(prev => prev - 1);
        }
    };

    const containerStyle = {
        display: "flex", 
        overflow: "hidden"
    }

    const animationStyle = {
        minWidth: "100%",
        transform: `translateX(-${currentIndex * 100}%)`,
        transition: "transform 0.5s ease-in-out"
    }

    return (
        <section className="kdcnews">
            <div className="kdcnews-wrap">
                <div className="kdcnews-title-wrap">
                    <h2 className="section-title">릴리즈<br />노트</h2>
                    <div className="btn-swiper">
                        <Link className={currentIndex === 0 ? 'dis' : ''} onClick={handlePrev}>
                            <i className="icoKdc40 prev"></i>
                        </Link>
                        <Link className={currentIndex === newsList.length - 1 ? 'dis': ''} onClick={handleNext}>
                            <i className="icoKdc40 next"></i>
                        </Link>
                    </div>
                </div>
                <div className="" style={containerStyle}>
                    {newsList.map((group, index) => {
                        return (
                            <ul key={index} className={`kdcnews-card-wrap`} style={animationStyle}>
                                {group?.map((data, index) => getCard(data, index))}
                            </ul>
                        )
                    })}
                </div>
            </div>
        </section>
    );
}
export default KdcNews;